import React, { useEffect, useRef, useState } from "react";

import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import { Button, Grid, Switch } from "@mui/material";

import filterIcon from "./../../../../assets/icons/filter 1.png";
import searchIcon from "./../../../../assets/icons/searchIcon 1.png";
import AddItemDialogComponent from "./AddItemDialog.tsx";

import FilterComponents from "../FilterComponents.tsx";
import SectionTable from "../SectionTable.tsx";
import AddSectionDialog from "../AddSectionDialog.tsx";
import burger from "./../../../../assets/icons/burger.png";
import edit from "./../../../../assets/icons/edit.png";
import bin from "./../../../../assets/icons/recycle-binColor.png";
import ediPencil from "./../../../../assets/icons/editPencil.png";
//table
import arrowUp from "./../../../../assets/icons/arrowup.png";
import arrowDown from "./../../../../assets/icons/arrowDown.png";
import Paper from "@mui/material/Paper";

import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import SectionItemsDialog from "../SectionItemsDialog/SectionItemsDialog.tsx";
//table end
import "./AddSection.css";
import CustomDataGrid from "../../../components/CustomDataGrid/CustomDataGrid.tsx";
import axios from "axios";
import EditSection from "../EditSection/EditSection.tsx";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import LoadingView from "../../../components/LoadingView/LoadingView";
import AddMenuDialog from "../AddMenuDialog.tsx";
import link from "./../../../../assets/icons/link.png";
import SweetAlertModal from "../../../components/SweetAlertModal/SweetAlertModal";
import LeftArrow from "../../../../assets/icons/left-arrow.png";
import RightArrow from "../../../../assets/icons/right-arrow.png";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper-bundle.min.css";
import "swiper/css";
import SectionLinkDialog from './../../components/SectionLinkDialog.tsx';
import MenuUnavailableModel from "./SectionUnavailableDialog.tsx";
//table start
interface Column {
  id: "checkBox" | "sectionid" | "sectionname" | "foodname";
  label: string;
  minWidth?: number;
  align?: "right";
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: "checkBox", label: "Check", minWidth: 100 },
  { id: "sectionid", label: "Id", minWidth: 100 },
  { id: "sectionname", label: "Name", minWidth: 100 },

  {
    id: "foodname",
    label: "Icon",
    minWidth: 100,
    align: "left",
    // format: (value: number) => value.toLocaleString('en-US'),
  },
];

function createData(sectionid: string, sectionname: string) {
  return { sectionid, sectionname };
}

const rows = [
  createData("B10101", "Standard", false),
  createData("B10101", "Special", false),
  createData("B10101", "Shop", false),
  createData("B10101", "Set menu", false),
];

//table end

function AddSection(props) {
  const [selectedData, setSelectedData] = useState({});

  const [openAddSection, setOpenAddSection] = useState(false);
  const [openAddMenu, setopenAddMenu] = useState(false);
  const [openEditSection, setOpenEditSection] = useState(false);
  const [dialogType, setDialogType] = useState("");

  const [openLinkConfirmaitonModal, setopenLinkConfirmaitonModal] =
    useState(false);

  const handleAddSectionDialogData = (data) => {
    setSelectedData(data);
  };
  const HandleNothing = () => {
  };
  const handleEditSectionDialogData = (data) => {
    setSelectedData(data);
  };
  const handleClickOpen = () => {
    console.log(selectedMenu);
    setOpenAddSection(true);
    setDialogType("add");
  };

  const errorToast = (msg) => {
    toast.error(msg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  };

  const handleClickAddMenuOpen = () => {
    setopenAddMenu(true);
    // alert("Menu")
  };
  const handleAddMenu = (AddSectionData) => {
    setopenAddMenu(false);
    loadMenuData();
  };
  const handleAddItem = (AddSectionData) => {
    setOpenAddSection(AddSectionData);
    setOpenMenuUnavailableDialog(AddSectionData)
    loadData(selectedMenu);
  };
  const handleEditItem = (AddSectionData) => {
    setOpenEditSection(AddSectionData);
    console.log(selectedMenu)
    loadData(selectedMenu);
  };
  const handleAddMenuDialogData = (data) => {
    loadMenuData();
  };
  //table start

  //table end
  const [value, setValue] = React.useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const [sectionItemsToggle, setsectionItemsToggle] = React.useState(false);
  const [sectionItemsdialogType, setsectionItemsdialogType] =
    React.useState("");
  const [sectionNameItemsdialogType, setsectionNameItemsdialogType] =
    React.useState("");
  const onHandlesectionItems = () => {
    setsectionItemsToggle(false);
  };
  const rows = [
    createData("B10101", "Standard", false),
    createData("B10102", "Special", false),
    createData("B10103", "Shop", false),
    createData("B10104", "Set menu", false),
  ];

  const [selectedSections, setSelectedSections] = React.useState([]);
  const [tempselectedSections, settempSelectedSections] = React.useState([]);
  const [countSelectedDatas, setcountSelectedDatas] = React.useState(0);
  React.useEffect(() => {
    setSelectedSections(tempselectedSections);
  }, [selectedSections]);

  const [Loading, setLoading] = React.useState(false);
  const changeOrderByTextBox = (props, type) => {
    console.log(props.target.value);
    console.log(type);
    if (props.target.value != "") {
      setLoading(true);
      if (lastRank - 1 < props.target.value || props.target.value == 0) {
        setLoading(false);
        toast.error("please select a valid number", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      }
      else if (type.displayOrder == props.target.value) {
        setLoading(false);
        toast.error("please change the rank", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      } else {
        axios
          .put(
            apiAddress +
            "/api/Section/updaterankwithtextboxsection?id=" +
            type.id +
            "&newRank=" +
            props.target.value
          )
          .then((response) => {
            console.log(response.data);
            setDataRows([]);
            toast.success("Successfully updated", {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "colored",
            });
            loadData(selectedMenu);
          });
      }
    }
  };

  const columnsdatas = [
    {
      field: "displayOrder",
      headerName: "Display Order",
      renderCell: (params) => (
        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
          <span
            className={`${params.row.displayOrder == 1 ? "deselct" : ""}`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              changeOrder(params.row, 2);
            }}
          >
            <img src={arrowUp} style={{ width: "1rem" }} />
          </span>
          <input
            type="number"
            className="form-control"
            style={{ width: "7rem" }}
            defaultValue={params.value}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                changeOrderByTextBox(event, params.row);
              }
            }}
          />
          <span
            className={`${params.row.displayOrder == lastRank - 1 ? "deselct" : ""
              }`}
            style={{ cursor: "pointer" }}
            onClick={() => {
              changeOrder(params.row, 1);
            }}

          >
            <img src={arrowDown} style={{ width: "1rem" }} />
          </span>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      width: 200,
    },
    {
      field: "type",
      headerName: "Section Type",
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "name",
      headerName: "Section Name",
      renderCell: (params) => (
        <div className="d-flex " style={{ gap: "10px" }}>
          <span
            onClick={() => {
              setsectionItemsToggle(true);
              setsectionItemsdialogType(params.row.id);
              setsectionNameItemsdialogType(params.value);
            }}
            style={{ color: "blue", cursor: "pointer" }}
          >
            {params.value}
          </span>
          <div
            style={{ color: "blue", cursor: "pointer" }}
            onClick={() => {
              onEditClick(params.row.id);
            }}
          >
            <img src={ediPencil} alt="" style={{ width: "1rem" }} />
          </div>
        </div>
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },

    {
      field: "icon",
      headerName: "Icon",
      renderCell: (params) => (
        <img
          src={params.value}
          alt="burger"
          style={{ width: "2rem", height: "2rem" }}
        />
      ),
      align: "center",
      headerAlign: "center",
      flex: 1,
    },
    {
      field: "isActive",
      headerName: "Active Status",
      align: "center",
      headerAlign: "center",
      flex: 1,
      renderCell: (params) => (
        <Switch
          checked={params.value}
          onChange={(event) => handleToggleChange(event, params.row)}
          color="primary"
          inputProps={{ "aria-label": "toggle" }}
          id={params.row.id}
        />
      ),
    },
  ];
  const [selectedDataForEdit, setSelectedDataForEdit] = useState();

  const changeOrder = (props, type) => {
    console.log(props);
    console.log(type);
    setLoading(true);
    axios
      .put(
        apiAddress +
        "/api/Section/updateranksection?id=" +
        props.id +
        "&status=" +
        type
      )
      .then((response) => {
        console.log(response.data);
        setDataRows([]);
        toast.success("Successfully updated", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        loadData(selectedMenu);
      });
  };

  const onEditClick = (props) => {
    console.log(props);
    var obj = dataCollection.find((x) => x.id == props);
    setSelectedDataForEdit(obj);
    setOpenEditSection(true);
  };

  const [selectedDataRows, setSelectedDatarows] = React.useState([]);
  const [selectedDataRowsCount, setSelectedDatarowsCount] = React.useState([]);

  const getselectedData = (props) => {
    console.log(props);
    console.log(value);
    console.log(dataRows);
    if (selectedDataRows[value] === undefined) {
      selectedDataRows[value] = [];
      selectedDataRowsCount[value] = [];
    }
    selectedDataRows[value] = props;
    selectedDataRowsCount[value] = props.length;
    setSelectedDatarowsCount(selectedDataRowsCount);
    console.log(selectedDataRows[value]);
    setSelectedDatarows(selectedDataRows);
    setcountSelectedDatas(props.length);
  };

  const [dataRows, setDataRows] = useState([]);

  const [lastRank, setLastRank] = useState(1);
  const [dataCollection, setDataCollection] = useState(0);
  const loadData = (props) => {
    if (props != undefined) {
      console.log(props);
      setLoading(true);
      const restaurant = localStorage.getItem("restaurant");
      var res = JSON.parse(restaurant);
      console.log(res);
      axios
        .get(
          apiAddress +
          "/api/Section/getallsectionbymenuid?id=" +
          props.id +
          "&restaurantId=" +
          res.id
        )
        .then((response) => {
          console.log(response.data);
          var list = [];
          var collectionList = response.data;
          setDataCollection(collectionList);
          if (response.data.length > 0) {
            response.data.map((dt, i) => {
              var obj = {
                id: dt.id,
                displayOrder: dt.rank,
                name: dt.keywordName,
                icon: dt.iconUrl,
                type: dt.sectionTypeId,
                isActive: dt.isActive,
                scheduleId : dt.scheduleId
              };
              list.push(obj);
            });
            // var list = [];
            // list.push(response.data)
            setDataRows(list);
            if (list.length > 0) {
              console.log(list.length);
              console.log(list[list.length - 1].displayOrder);
              var rank = list[list.length - 1].displayOrder;

              setLastRank(rank + 1);
            } else {
              setLastRank(1);
            }
          }

          setLoading(false);
        });
    }
  };

  useEffect(() => {
    console.log("called");
    loadMenuData();
  }, []);

  const deleteBin = () => {
    var valid = true;
    console.log(selectedDataRows);

    if (selectedDataRows[value] == undefined) {
      valid = false;
      toast.error("please select any section", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      axios
        .put(
          apiAddress + "/api/Section/deletesection?status=0",
          selectedDataRows[value]
        )
        .then((response) => {
          console.log(response.data);
          setDataRows([]);
          console.log(selectedMenu);
          loadData(selectedMenu);
        });
    }
  };
  const apiAddress = process.env.REACT_APP_SECRET;
  const [tabViewItemList, settabViewItemList] = React.useState([]);

  const loadMenuData = () => {
    const restaurant = localStorage.getItem("restaurant");
    var res = JSON.parse(restaurant);
    console.log(res);
    axios
      .get(
        apiAddress +
        "/api/Menu/GetAllMenuIconListByRestaurantIdAsync?restaurantId=" +
        res.id
      )
      .then((response) => {
        console.log(response.data);
        if (response.data.length > 0) {
          settabViewItemList(response.data);
          loadData(response.data[0]);
          setselectedMenu(response.data[0]);
        }
      });
  };
  const [selectedMenu, setselectedMenu] = useState();

  const onTabClick = (data) => {
    setselectedMenu(data);
    setDataRows([]);
    loadData(data);
  };

  const TabViewItem = ({ children, count, data }) => {
    console.log("count: " + count);
    console.log("value: " + value);
    return (
      <div
        onClick={() => {
          onTabClick(data);
        }}
      >
        {<div>{children}</div>}
      </div>
    );
  };
  console.log(lastRank);

  const LinkSection = () => {
    console.log(selectedDataRows[value]);

    var url = apiAddress + "/api/Section/LinkSection";

    axios.put(url, selectedDataRows[value]).then((response) => {
      toast.success("Sections successfully Linked", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });

      //loadData();
    });
    setopenLinkConfirmaitonModal(false);
  };

  const [activeTab, setActiveTab] = useState(0);

  const swipperClick = (index) => {
    handleTabClick(index);
  }

  const handleTabClick = (index) => {
    console.log("changed: ", index);
    setActiveTab(index);
  };

  const sliderRef = useRef(null);

  const handleNext = (swiperRef) => {
    swiperRef.current.swiper.slideNext();
  };

  const handlePrev = (swiperRef) => {
    swiperRef.current.swiper.slidePrev();
  };

  const [openLinkModal, setopenLinkModal] = useState(false);
  const handleLinkModel = () => {
    setopenLinkModal(true);
  }
  const hanldeLinkmodalclose = () => {
    setopenLinkModal(false);
  }

  const [selectedRowId, setSelectedRowId] = useState(null);
  const [openMenuUnavailableDialog, setOpenMenuUnavailableDialog] = useState(false);
  const [openMenuAvailableDialog, setOpenMenuAvailableDialog] = useState(false);

  const handleToggleChange = (event, id) => {
    console.log(id)
    if (id.isActive == false) {
      setSelectedRowId(id.id);
      setOpenMenuAvailableDialog(true);
    } else {
      setOpenMenuUnavailableDialog(true);
      setSelectedRowId(id.id);
      //setSelectedDataRow(id);
    }
  };

  const MenuActivate = () => {
    console.log(selectedRowId)

    if (selectedRowId != undefined) {
      axios({
        method: "put",
        url:
          apiAddress + "/api/Section/SetSectionAvailable?sectionId=" + selectedRowId,
      })
        .then((response) => {
          toast.success("Section activated", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
          loadData(selectedMenu);
        });
      setOpenMenuAvailableDialog(false);
    }
  }

  return (
    <div>
      <ToastContainer></ToastContainer>
      <LoadingView
        open={Loading}
        close={() => {
          setLoading(false);
        }}
      />

      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"Do you want to link these Sections"}
        open={openLinkConfirmaitonModal}
        onyes={LinkSection}
        close={() => {
          setopenLinkConfirmaitonModal(false);
        }}
      />
      <SweetAlertModal
        headerText={"Are you sure?"}
        bodyText={"This action will activate this Section"}
        open={openMenuAvailableDialog}
        onyes={MenuActivate}
        close={() => {
          setOpenMenuAvailableDialog(false);
        }}
      />

      {tabViewItemList.length > 0 ? (
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <div className="slider-container">
              {/* Previous Button */}
              <button
                onClick={() => {
                  handlePrev(sliderRef);
                }}
                className="arrow-btn"
              >
                <img src={LeftArrow} alt={"arrow"} />
              </button>
              {/* Slider sections */}
              <Swiper
                spaceBetween={10}
                slidesPerView={'auto'}
                ref={sliderRef}
              // breakpoints={{
              //   1326: {
              //   }
              // }}
              >
                <TabList
                  // onChange={handleChange}
                  aria-label="lab API tabs example"
                  variant="scrollable"
                  scrollButtons="auto"
                >
                  {tabViewItemList.map((dt, i) => {
                    return (
                      // <Tab label={dt.menuName} value={i} />
                      <SwiperSlide
                        key={i}
                        style={{ width: "auto" }}
                        className={i === activeTab ? "tab-active" : ""}
                      >
                        <Tab
                          className="p-0"
                          label={
                            <TabViewItem count={i} data={dt}>
                              <div style={{padding: '13px' }}>
                                {dt.menuName}
                              </div>
                            </TabViewItem>
                          }
                          value={i}
                          onClick={() => handleTabClick(i)}
                        />
                      </SwiperSlide>
                    );
                  })}
                </TabList>
              </Swiper>
              {/* Next Button */}
              <button
                onClick={() => {
                  handleNext(sliderRef);
                }}
                className="arrow-btn"
              >
                <img src={RightArrow} alt="arrow" />
              </button>
              {/* AddNew Button */}
              <div className="mt-1 add-btn-section">
                <button
                  className="btn btnAddNew"
                  onClick={handleClickAddMenuOpen}
                >
                  + Add new
                </button>
              </div>

            </div>
          </Box>

          {/* Data Grid and Options */}
          {tabViewItemList.map((dt, i) => {
            return (
              // <Tab label={dt.menuName} value={i} />
              value == i ? (
                <div>
                  {/* Options [detete, addnew etc.] */}
                  <Grid
                    container
                    alignItems="center"
                    justifyContent="space-between"
                    mt={2}
                    mb={2}
                    sx={{ width: '83%'}}
                  >
                    <Grid item>
                      <Grid container spacing={2} alignItems="center">
                        <Grid item>
                          <Button
                            color="primary"
                            size="medium"
                            variant="contained"
                            style={{ borderRadius: "50%", minWidth: "auto" }}
                            onClick={handleClickOpen}
                          >
                            +
                          </Button>
                        </Grid>
                        {/* <Grid item>
                          <img
                            src={filterIcon}
                            alt=""
                            style={{ width: "1rem" }}
                          />
                        </Grid>
                        <Grid item>Add Filter</Grid> */}

                        <Grid item>
                          <div className="roundedCorner">
                            <img
                              src={link}
                              alt=""
                              style={{ width: "1rem" }}
                              onClick={() => {
                                handleLinkModel()
                              }}
                            />
                          </div>
                        </Grid>

                        <Grid item>
                          <div className="roundedCorner">
                            <img
                              src={bin}
                              alt=""
                              style={{ width: "1rem" }}
                              onClick={() => {
                                deleteBin();
                              }}
                            />
                          </div>
                        </Grid>
                        <Grid item></Grid>
                      </Grid>
                    </Grid>
                    <Grid item>
                      <Grid
                        container
                        flexDirection={"column"}
                        alignItems={"center"}
                      >
                        {/* <Grid item>
                          <img
                            src={searchIcon}
                            alt=""
                            style={{ width: "1rem" }}
                          />
                        </Grid>
                        <Grid item>Search</Grid> */}
                      </Grid>
                    </Grid>
                  </Grid>

                  {/* DataGrid */}
                  <Paper sx={{ width: "83%", overflow: "hidden" }}>
                    {dataRows.length > 0 ? (
                      selectedDataRows[value] != undefined ? (
                        <CustomDataGrid
                          columns={columnsdatas}
                          dataRows={dataRows}
                          getselectedData={getselectedData}
                          selectedRows={selectedDataRows[value]}
                          isLoading={Loading}
                        />
                      ) : (
                        <CustomDataGrid
                          columns={columnsdatas}
                          dataRows={dataRows}
                          getselectedData={getselectedData}
                        />
                      )
                    ) : (
                      "No Data found"
                    )}
                  </Paper>
                </div>
              ) : (
                ""
              )
            );
          })}
        </TabContext>
      ) : (
        <div className="mt-1">
          <button className="btn btnAddNew" onClick={handleClickAddMenuOpen}>
            + Add new
          </button>
        </div>
      )}

      {openAddSection ? (
        <>
          <AddSectionDialog
            open={openAddSection}
            dialogType={"Add Section"}
            onHandleAddItem={handleAddItem}
            onHandleSelectedData={handleAddSectionDialogData}
            lastRank={lastRank}
            menu={selectedMenu}
            loaddataonfly={HandleNothing}
          />
        </>
      ) : (
        <></>
      )}
      {openEditSection ? (
        <EditSection
          open={openEditSection}
          dialogType={"Add Section"}
          onHandleAddItem={handleEditItem}
          selectedDataForEdit={selectedDataForEdit}
        />
      ) : (
        ""
      )}
      {openAddMenu ? (
        <AddMenuDialog
          open={openAddMenu}
          dialogType={"Menu"}
          onHandleAddItem={handleAddMenu}
          onHandleSelectedData={handleAddMenuDialogData}
        />
      ) : (
        ""
      )}

      {sectionItemsToggle ? (
        <SectionItemsDialog
          open={sectionItemsToggle}
          dialogType={sectionItemsdialogType}
          onHandleAddItem={onHandlesectionItems}
          sectionName={sectionNameItemsdialogType}
          type={1}
        />
      ) : (
        ""
      )}
      {openLinkModal &&
      <SectionLinkDialog
        open={openLinkModal}
        linkmodalclose={hanldeLinkmodalclose}
        Openfrom={"Main"}
      />
      }

      {openMenuUnavailableDialog &&
        <MenuUnavailableModel
          open={openMenuUnavailableDialog}
          selectedMenuId={selectedRowId}
          onHandleAddItem={handleAddItem}
        //eidtData={EditMenudObj}
        />}
    </div>
  );
}

export default AddSection;
